<template>
    <Message :severity="type" :closable="closable" :sticky="true">
        <slot>{{title}}</slot>
    </Message>
</template>

<script>
import { ref, watch } from 'vue'
import Message from 'primevue/message';

export default {
    name: 'tw-alert',
    components: {
        Message
    },
    setup(props, context) {
        const text = ref(props.value)

        watch(text, (newValue) => {
            context.emit('update:value', newValue)
        })

        return {
            text
        }
    },
    props: {
        title: {
            type: String,
            default: "信息"
        },
        type: String,
        closable: {
            type: Boolean,
            default: true
        }
    }
}
</script>
